import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { HelpModule } from '../../UI-Lib/Help-Tooltip/help.module';
import { CommentModalData, CommentsService } from '../comments.service';
import { CommentsModalService } from '../commentsModal.service';
import * as _ from 'lodash';
import { EntityTypeIDs } from 'src/app/constants.new';

@Component({
    selector: 'entity-comments',
    templateUrl: './entityCommentsButton.component.html',
    imports: [CommonModule, HelpModule],
})
export class EntityCommentsButtonComponent implements OnChanges {
    constructor(
        private readonly _commentsModalService: CommentsModalService,
        private readonly _commentsService: CommentsService,
    ) {}

    @Input() pinnedComment?: string;
    @Input() hasComments: boolean;
    @Input() buttonClass: string;
    @Input() getModalData: () => CommentModalData;
    @Input() modalData: CommentModalData;
    @Input() disabled: boolean;
    @Input() isNestedModal: boolean;
    @Input() tooltipPosition: string = 'bottom';

    @Output() hasCommentsChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() commentCountChange: EventEmitter<number> = new EventEmitter<number>();

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (this.isNewEntity(changes['modalData'])) {
            const pinnedCommentObj = await this._commentsService.getPinnedComment(
                this.modalData.entityID,
                this.modalData.entityTypeID,
                this.modalData.year,
                this.modalData.commentTypeID,
            );

            this.pinnedComment = pinnedCommentObj?.description;
        }
    }

    async showCommentsDialog(): Promise<void> {
        const modalData = this.modalData || (this.getModalData && this.getModalData());

        const commentData = await this._commentsModalService.openCommentModal(modalData);

        this.hasComments = !!commentData.commentCount;
        this.pinnedComment = commentData.pinnedComment;
        this.hasCommentsChange.emit(this.hasComments);
        this.commentCountChange.emit(commentData.commentCount);
    }

    private isNewEntity(modalDataChange?: SimpleChange): boolean {
        if (!modalDataChange?.currentValue) {
            return false;
        }

        const { entityID, entityTypeID } = modalDataChange.currentValue;

        if (
            entityTypeID !== EntityTypeIDs.COMPANY &&
            entityTypeID !== EntityTypeIDs.SITE &&
            entityTypeID !== EntityTypeIDs.PARCEL
        ) {
            return false;
        }

        return (
            modalDataChange.previousValue?.entityID !== entityID ||
            modalDataChange.previousValue?.entityTypeID !== entityTypeID
        );
    }
}
